const CANVAS_SIZE = [235, 445];
const SNAKE_START = [
  [10, 9],
  [10, 10]
];
const APPLE_START = [10, 3];
const SCALE = 13;
const SPEED = 100;
const DIRECTIONS = {
  38: [0, -1], // up
  40: [0, 1], // down
  37: [-1, 0], // left
  39: [1, 0] // right
};
const appleRadius = 0.3;
const NUMBER_OF_APPLES = 9;
export {
  CANVAS_SIZE,
  SNAKE_START,
  APPLE_START,
  SCALE,
  SPEED,
  DIRECTIONS,
  NUMBER_OF_APPLES,
  appleRadius
};
